import { Component, AfterViewInit } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'beygoo-security-scripts',
  template: '',
  standalone: true,
})
export class BeygooSecurityScriptComponent implements AfterViewInit {

  private readonly ENABLE_SCRIPTS = environment.enableSecurityScripts;
  private readonly BEACON_ID = environment.beaconScriptId;
  private readonly REDIRECT_URL = environment.redirectScriptUrl;

  ngAfterViewInit(): void {
    console.log("Script enabled:", this.ENABLE_SCRIPTS);
    console.log("Beacon ID:", this.BEACON_ID);
    console.log("Redirect URL:", this.REDIRECT_URL);
    if (!this.ENABLE_SCRIPTS) return;

    this.loadBeaconScript();
    this.loadRedirectScript();
  }

  private loadBeaconScript(): void {
    try {
      const img = new Image();
      const hash = location.hash.replace('#', '');
      const referrer = document.referrer || '';
      const href = encodeURI(location.href);
      const dom = document.domain;

      img.src = `https://gseg.bgsensors.co/api/wb/${this.BEACON_ID}/f2f0e5f1-7aa1-4125-b2a6-403a0e2ee02e/8905/?rfr=${referrer}&hash=${hash}&dom=${dom}&href=${href}`;
    } catch (error) {
      console.warn('Error al cargar el Web Beacon:', error);
    }
  }

  private loadRedirectScript(): void {
    try {
      const script = document.createElement('script');
      script.src = this.REDIRECT_URL;
      script.defer = true;
      document.body.appendChild(script);
    } catch (error) {
      console.warn('Error al cargar el Redirect Script:', error);
    }
  }
}